import { css as e } from "@microsoft/fast-element";
import { normalize as r } from "../common/normalize.js";
import { display as o } from "@matrix42/fast-foundation";
import { designTokens as t } from "../design-tokens.js";
const i = e`
  ${r}
  ${o("flex")}
  .control {
    /* Layout */
    position: relative;
  }

  svg {
    /* Style */
    width: 100%;
    height: 100%;
  }

  svg > text {
    /* Typography */
    font-family: ${t.fontFamily.sans};
    font-weight: 600;
    font-style: normal;
    text-anchor: middle;
    dominant-baseline: central;
    /* Style */
    fill: ${t.color.neutral[100]};
  }

  svg > circle {
    /* Style */
    stroke: transparent;
  }

  svg > circle + circle {
    /* Style */
    stroke: ${t.color.neutral[100]};
    stroke-linecap: round;
    stroke-dasharray: var(--nova-timer-percentage) 1;
    stroke-dashoffset: -2;
    transform: rotate(-90deg);
  }
`;
export {
  i as timerStyles
};
